import { useNavigate } from "react-router-dom";
import { useLogin } from "../../api";
import {
  REFRESH_KEY,
  TOKEN_KEY,
  USER_DETAILS_KEY,
} from "../../components/providers/authProvider";
import { useNotification } from "@refinedev/core";
import { getErrorMessage } from "../../api/error";

const useAuth = () => {
  const navigate = useNavigate();
  const { open: openNotification } = useNotification();

  const { mutate: login, isLoading: loadingLogin } = useLogin({
    onSuccess: (response: {
      data?: {
        data?: {
          tokens: { access_token: string; refresh_token: string };
          details: any;
        };
      };
    }) => {
      const dataUser = response?.data?.data;
      localStorage.setItem(TOKEN_KEY, dataUser?.tokens?.["access_token"] ?? "");
      localStorage.setItem(REFRESH_KEY, dataUser?.tokens?.["refresh_token"] ?? "");
      localStorage.setItem(
        USER_DETAILS_KEY,
        JSON.stringify(dataUser?.details)
      );
      navigate("/");
    },
    onError: (error: { message: "" }) => {
      console.log(error);
      const message = getErrorMessage(error);
      openNotification?.({
        key: "error",
        message: message || "Login failed!",
        type: "error",
      });
    },
  });

  return {
    login,
    loadingLogin,
  };
};

export default useAuth;
